import { useTranslation } from 'react-i18next'

import { ContentSpinner } from 'src/components'

import { WorkspacePageShell, useWorkspaceRoute } from '../WorkspacePageShell'

import { ConnectDrawer } from './ConnectDrawer'
import { ConnectionsTable } from './ConnectionsTable'
import { useMyMcpServices } from './hooks'
import { canManageMcp } from './model'

export const WorkspaceAiConnectorsPage = () => {
  const { t } = useTranslation()
  const { workspaceId } = useWorkspaceRoute()
  // Same query the Connect wizard reads; `can_manage` is Core's own admin verdict.
  const { data: services = [], isLoading } = useMyMcpServices(workspaceId)
  const isAdmin = canManageMcp(services)

  return (
    <WorkspacePageShell
      sectionTitle={t('workspace.aiConnectors.sectionTitle')}
      sectionDescription={t('workspace.aiConnectors.sectionDescription')}
    >
      {/* Until can_manage is known, an admin would briefly see only their own list. */}
      {isLoading ? (
        <ContentSpinner minHeight={240} />
      ) : (
        <ConnectionsTable
          workspaceId={workspaceId}
          scope={isAdmin ? 'org' : 'mine'}
          action={<ConnectDrawer workspaceId={workspaceId} isAdmin={isAdmin} />}
        />
      )}
    </WorkspacePageShell>
  )
}
